import ODAS from '@/utils/api/odas';

let pollingStartTime = {};

const PDF = {
  requestPdf: ({ pdfData, dataKey, locale }) => {
    var params = {
      pdf: {
        locale
      }
    };
    params[dataKey] = pdfData;
    return ODAS.post('/api/pdfs', params).then((response) => response.response);
  },
  getPdf: ({ key, file_name }) => {
    return ODAS.get(
      '/api/pdfs?content_disposition_format=inline&key=' + encodeURIComponent(key) + '&file_name=' + encodeURIComponent(file_name)
    ).then((response) => response.response);
  },
  generatePdf: ({ ...request }) => {
    return PDF.requestPdf(request).then(PDF.getPdf);
  },
  pollForPdf: async (key, fileName, timeout = 0) => {
    let totalTimeout = timeout || PDF.TIMEOUT;
    if (typeof pollingStartTime[key] === 'undefined') {
      pollingStartTime[key] = Date.now();
    }
    while (pollingStartTime[key] + totalTimeout > Date.now()) {
      const response = await PDF.getPdf({ key, file_name: fileName });
      if (response?.ready) {
        delete pollingStartTime[key];
        return response;
      } else {
        // use this to sleep for 3 seconds
        await new Promise((r) => setTimeout(r, 3000));
      }
    }
    delete pollingStartTime[key];
    throw new Error('PDF generation timed out, please try again.');
  },
  TIMEOUT: 60000
};

export default PDF;
